const NIST_ACTION_TYPES = ['govern', 'map', 'measure', 'manage'];

const NIST_ACTION_STATUS_COLORS = ['primary', 'secondary', 'success'];
const NIST_ACTION_STATUS_COLORS_HEX = ['#1976d2', '#9c27b0', '#2e7d32'];
const NIST_ACTION_STATUS_COLOR_9_HEX = [
  ['#42a5f5', '#1976d2', '#1565c0'],
  ['#ba68c8', '#9c27b0', '#7b1fa2'],
  ['#4caf50', '#2e7d32', '#1b5e20']
];
const NIST_ACTION_STATUSES = ['To Do', 'In Progress', 'Completed'];
const NIST_ACTION_STATUSES_OPTS = [
  { label: 'To Do', value: 'To Do' },
  { label: 'In Progress', value: 'In Progress' },
  { label: 'Completed', value: 'Completed' }
];

const COMPLIANCE_TABS = [
  { name: 'DASHBOARD', route: 'dashboard', match: '/compliance/:orgId/dashboard/*' },
  { name: 'USERS', route: 'users', match: '/compliance/:orgId/users' },
  { name: 'PRODUCTS', route: 'products', match: '/compliance/:orgId/products' },
  { name: 'ACTIONS', route: 'actions', match: '/compliance/:orgId/actions' },
  { name: 'DOCUMENTS', route: 'documents', match: '/compliance/:orgId/documents' },
  { name: 'RISKS', route: 'risks', match: '/compliance/:orgId/risks' },
  { name: 'CUSTOM POLICIES', route: 'custom-policies', match: '/compliance/:orgId/custom-policies' }
  // { name: 'NIST', route: 'nist' }
];

const COMPLIANCE_DYNAMIC_TABS = [
  { name: 'Canada', route: 'canada' },
  { name: 'EU', route: 'eu' },
  { name: 'UK', route: 'uk' }
];

// Directly reference the actual icon components instead of their string names.
const VERTICAL_TABS = [
  { name: 'STATUS SUMMARY', menu: 'Status Summary', route: 'status-summary', icon: 'dashboard' },
  { name: 'PRODUCT TYPES', menu: 'Product Types', route: 'product-types', icon: 'products' },
  { name: 'TOP ACTIVITIES', menu: 'Top Activities', route: 'top-activities', icon: 'actions' },
  { name: 'TOP USERS', menu: 'Top Users', route: 'top-users', icon: 'users' },
  { name: 'RISKS', menu: 'Risks', route: 'risks', icon: 'risks' },
  { name: 'NIST', menu: 'NIST', route: 'nist', icon: 'nist' },
  { name: 'POSTURE', menu: 'Posture', route: 'posture', icon: 'posture' },
  { name: 'MAP', menu: 'Map', route: 'map', icon: 'map' }
];

const NIST_COLOR_MAP = {
  map: '#42a5f5',
  govern: '#1976D2',
  measure: '#0288d1',
  manage: '#01579b'
};

const ACTIVITY_COLOR_MAP = {
  action: '#42a5f5',
  document: '#1976D2'
};

const PRODUCT_TYPES = {
  THIRD_PARTY: 'thirdParty',
  INTERNAL: 'internal',
  JIRA: 'jira'
};
const PRODUCT_TYPES_OPTIONS = [
  { value: 'thirdParty', label: 'Third Party' },
  { value: 'internal', label: 'Internal' },
  { value: 'jira', label: 'Jira' }
];
const RISK_PRODUCT_TYPES = [PRODUCT_TYPES.INTERNAL, PRODUCT_TYPES.JIRA, PRODUCT_TYPES.THIRD_PARTY];

const RISK_SOURCES = ['AI', 'Employee', 'Role'];

const RISK_SCALE_VALUES = [
  { value: 1, label: 'Extremely Unlikely', color: '#40c000' },
  { value: 2, label: 'Improbable', color: '#8cca13' },
  { value: 3, label: 'Remote', color: '#d8d526' },
  { value: 4, label: 'Occasional', color: '#ffb027' },
  { value: 5, label: 'Frequent', color: '#ff5814' },
  { value: 6, label: 'Extremely Likely', color: '#ff0000' }
];

const DEPARTMENTS = [
  { value: 'sales', label: 'Sales' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hr', label: 'HR' },
  { value: 'grc', label: 'GRC' },
  { value: 'legal', label: 'Legal' },
  { value: 'inventory', label: 'Inventory' },
  { value: 'finance', label: 'Finance' },
  { value: 'development', label: 'Development' }
];

const DEFAULT_PRODUCT = {
  _id: null,
  product_name: '',
  manufacturer: '',
  description: '',
  descriptions: [
    {
      text: '',
      source: 'plain'
    }
  ],
  org_id: null,
  baseProductId: null,
  type: PRODUCT_TYPES.THIRD_PARTY,
  department: '',
  decisionType: 'none',
  technology: [],
  source: [],
  actions: [],
  documents: [],
  jira_key: null,
  productsIn: [],
  implementationStatus: '',
  citations: [],
  decisionThreshold: '',
  version: '1.0',
  isActive: true,
  createdAt: '',
  updatedAt: ''
};

export const DEFAULT_ORG = {
  _id: null,
  name: '',
  org_id: null,
  parent_id: null,
  logoUrl: '',
  regulations: [],
  actions: [],
  documents: [],
  location: {
    country: '',
    city: '',
    lat: null,
    lng: null
  }
};
export const DECISION_TYPES = [
  { label: 'None', value: 'none' },
  { label: 'AI', value: 'ai' },
  { label: 'Human', value: 'human' },
  { label: 'Hybrid', value: 'hybrid' }
];
export const IMPLEMENTATION_STATUSES = [
  { value: 'In Production', label: 'In Production' },
  { value: 'Under Testing', label: 'Under Testing' },
  { value: 'Under Development', label: 'Under Development' },
  { value: 'Ideation', label: 'Ideation' }
];
export const TECHNOLOGY_TYPES = [
  { label: 'A2A', value: 'A2A' },
  { label: 'MCP', value: 'MCP' },
  { label: 'LLM', value: 'LLM' },
  { label: 'RAG', value: 'RAG' },
  { label: 'Agent', value: 'Agent' }
];
export const DECISION_THRESHOLD_OPTIONS = [
  { label: '$10K', value: 10000 },
  { label: '$50K', value: 50000 },
  { label: '$100K', value: 100000 }
];
export const PRODUCT_INFO_TYPES = [
  { value: 'pii', label: 'PII' },
  { value: 'phi', label: 'PHI' },
  { value: 'pci', label: 'PCI' },
  { value: 'glba_sox_pifi', label: 'GLBA/SOX/PIFI' },
  { value: 'spd', label: 'SPD' },
  { value: 'nsi', label: 'NSI' },
  { value: 'ip', label: 'IP' },
  { value: 'business', label: 'BUSINESS' }
];

export {
  ACTIVITY_COLOR_MAP,
  COMPLIANCE_DYNAMIC_TABS,
  COMPLIANCE_TABS,
  DEFAULT_PRODUCT,
  DEPARTMENTS,
  NIST_ACTION_STATUS_COLOR_9_HEX,
  NIST_ACTION_STATUS_COLORS,
  NIST_ACTION_STATUS_COLORS_HEX,
  NIST_ACTION_STATUSES,
  NIST_ACTION_STATUSES_OPTS,
  NIST_ACTION_TYPES,
  NIST_COLOR_MAP,
  PRODUCT_TYPES,
  PRODUCT_TYPES_OPTIONS,
  RISK_PRODUCT_TYPES,
  RISK_SCALE_VALUES,
  RISK_SOURCES,
  VERTICAL_TABS
};
